(function () {
  angular.module("akitabox.ui.components.typeAheadInput", [
    "ngMaterial",
    "akitabox.core",
    "angular.filter",
  ]);
})();
